/* RESPONSIBLE TEAM: team-fin-voice */
/* eslint-disable @intercom/intercom/no-bare-strings */

export type FinVoicePipelineOptions = {
  value: FinVoicePipeline;
  text: string;
};

export type FinVoicePipeline =
  | 'default'
  | 'realtime-phased-answer-v1'
  | 'realtime-frontline-agent-experimental-v1';

export const FIN_VOICE_PIPELINE_OPTIONS: FinVoicePipelineOptions[] = [
  { value: 'default', text: 'Default' },
  { value: 'realtime-phased-answer-v1', text: 'Realtime Phased Answer v1' },
  {
    value: 'realtime-frontline-agent-experimental-v1',
    text: 'Realtime Frontline Agent Experimental v1',
  },
];
